<template>
  <div>
    <load-profile :key="triggerLoadProfile" />
    <b-card>
      <div v-if="chatPartnerConfig" class="btn-container">
        <n-button-loading
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          type="submit"
          variant="primary"
          class="mt-1"
          :loading="loading"
          @submit="toggleChatMeEligibility"
        >
          {{
            chatPartnerConfig.isEnablePrivateChat
              ? $t("button.disable")
              : $t("button.enable")
          }}
        </n-button-loading>
        <n-button-loading
          v-if="!chatPartnerConfig.appId"
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          type="submit"
          variant="primary"
          class="mt-1"
          :loading="generateLoading"
          :disabled="!chatPartnerConfig.isEnablePrivateChat"
          @submit="generateChatMeConfig"
        >
          {{ $t("button.generate") }}
        </n-button-loading>
      </div>
      <p class="pt-2" style="font-size: 18px; font-weight: bold">
        {{ $t("general.partnerConfiguration") }}
      </p>
      <partner-config
        v-if="chatPartnerConfig"
        :key="chatPartnerConfig.appId"
        :data="chatPartnerConfig"
        :disabled="!chatPartnerConfig.isEnablePrivateChat"
      />
    </b-card>
  </div>
</template>

<script>
import { BCard, BRow, BCol } from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import Repository from "@/repositories/RepositoryFactory";
import NButtonLoading from "@/components/NButtonLoading";
import PartnerConfig from "./PartnerConfiguration.vue";

const IntegrationRepository = Repository.get("integration");

export default {
  components: {
    BCard,

    PartnerConfig,
    NButtonLoading,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      loading: false,
      generateLoading: false,
      chatPartnerConfig: null,
      triggerLoadProfile: 0,
    };
  },
  computed: {
    MAX_USER_SESSION_EXPIRES_IN() {
      return 10080;
    },
  },
  mounted() {
    this.show();
  },
  methods: {
    show() {
      IntegrationRepository.showChatMe()
        .then((response) => {
          const data = response?.data?.data;
          if (data) {
            this.chatPartnerConfig = { ...data };
          }
        })
        .catch();
    },
    toggleChatMeEligibility() {
      this.loading = true;
      IntegrationRepository.toggleChatMeEligibility()
        .then((response) => {
          const data = response?.data?.data;
          if (data) {
            this.triggerLoadProfile += 1;
            this.chatPartnerConfig = {
              ...this.chatPartnerConfig,
              isEnablePrivateChat: data.isEnablePrivateChat,
            };
          }
        })
        .catch()
        .then(() => {
          this.loading = false;
        });
    },
    generateChatMeConfig() {
      this.generateLoading = true;
      IntegrationRepository.generateChatMeConfig({
        mode: window.VUE_APP_CHAT_ME_MODE,
      })
        .then((response) => {
          const data = response?.data?.data;
          if (data) {
            this.triggerLoadProfile += 1;
            this.chatPartnerConfig = { ...data };
          }
        })
        .catch()
        .then(() => {
          this.generateLoading = false;
        });
    },
  },
  setup() {
    const permissionType = "private-chat-integration";

    return { permissionType };
  },
};
</script>

<style scoped>
.btn-container {
  display: flex;
  gap: 10px;
}
</style>
